"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
function ProductCategoryGridConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 md:gap-8">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i}>
            <Skeleton className="h-[400px] w-full rounded-xl shadow-md" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-16 bg-muted/30 rounded-2xl border border-border">
        <p className="text-muted-foreground font-sans">A apărut o eroare la încărcarea colecțiilor.</p>
      </div>;
  }
  if (!terms || terms.length === 0) {
    return <div className="text-center py-16 bg-muted/30 rounded-2xl border border-border">
        <p className="text-muted-foreground font-sans">Nu am găsit colecții disponibile momentan.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 md:gap-8">
      {terms.map((term, i) => <Link key={term.id} to={term.link || "#"} data-index={i} className="group block outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-xl">
          <Card className="overflow-hidden border-0 shadow-lg transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl bg-card rounded-xl h-full">
            <div className="relative h-full">
              <AspectRatio ratio={4 / 5} className="bg-muted overflow-hidden h-full">
                {term.image_url ? <img src={term.image_url} alt={term.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" /> : <div className="h-full w-full bg-secondary/10 flex items-center justify-center">
                    <span className="text-muted-foreground font-serif italic">Fără imagine</span>
                  </div>}
              </AspectRatio>
              
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent pointer-events-none" />
              
              <div className="absolute bottom-0 left-0 right-0 p-6 flex items-end justify-between z-10">
                <div className="pr-4">
                  <h3 className="font-serif text-2xl font-semibold text-white mb-1 group-hover:text-primary transition-colors duration-300">
                    {term.name}
                  </h3>
                  {term.description && <p className="text-white/70 text-sm line-clamp-1 font-sans">
                      {term.description}
                    </p>}
                </div>
                <Badge className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-md border-none shrink-0 h-8 px-3 rounded-md transition-transform duration-300 group-hover:scale-105">
                  <ArrowRight className="size-4" />
                </Badge>
              </div>
            </div>
          </Card>
        </Link>)}
    </div>;
}
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 4,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
export default function ProductCategoryGrid() {
  return <section id="productcategorygrid" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-foreground">
            Descoperă Colecția Noastră
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto rounded-full mb-6" />
          <p className="text-muted-foreground text-lg font-sans">
            Explorează selecția noastră premium de bijuterii, create cu atenție la detalii pentru a-ți sublinia eleganța în fiecare zi.
          </p>
        </div>

        <EcommerceTermsProvider wp_term_query={wp_term_query}>
          <ProductCategoryGridConsumer />
        </EcommerceTermsProvider>
      </div>
    </section>;
}